import { authHeader, handleResponse } from './helper';
import config from '../config';
import { getCookie } from './cookies';

export const sendOrderToEdxEcg = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branchOfficeId: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiEdxEcgUrl}/order/sendOrder`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const ecgService = {
  sendOrderToEdxEcg,
};
